export default "__VITE_ASSET__5e7c307e__"